<div class="container">
  <div class="entity-toolbar">
    <div class="left-tools">
      <button class="icon-button" [class.active]="viewMode === 'detail'" (click)="onViewChange('detail')"
        title="Detail View">
        <i class="fa fa-list"></i>
      </button>
      <button class="icon-button" [class.active]="viewMode === 'card'" (click)="onViewChange('card')" title="Card View">
        <i class="fa fa-th-large"></i>
      </button>
    </div>

    <button class="add-entity-button" (click)="openAddCourse()" title="Add Course">
      <i class="fa fa-plus" aria-hidden="true"></i>Add Course</button>
  </div>


  <div class="entity-card-list" *ngIf="viewMode === 'detail'">
    <div class="entity-card-header">
      <span>Course Code</span>
      <span>Name</span>
      <span>Provider</span>
      <span>Description</span>
      <span>Lab Count</span>
      <span class="grid-column">Actions</span>
    </div>
    <div class="entity-card-row" *ngFor="let course of courses">
      <span>{{ course.code }}</span>
      <span>{{ course.name }}</span>
      <span>{{ course.provider }}</span>
      <span>{{ course.description }}</span>
      <span>{{ getLabCount(course) }} Labs</span>
      <!-- <span class="actions"> <button class="icon-button" (click)="editCourse(course)">
          <i class="fa fa-pen"></i>
        </button>&nbsp;
        <button class="icon-button" (click)="viewCourseDetails(course)">
          <i class="fa fa-eye"></i>
        </button>


      </span> -->
       <span class="actions">
        <i class="fa fa-ellipsis-v menu-icon" (click)="toggleMenu($event, course)"></i>
        <div class="dropdown-menu" [ngClass]="{'show': course.id === selectedCourseId}">
          <div class="menu-item" (click)="editCourse(course)" title="Edit Course Details">
            <i class="fa fa-pencil"></i> Edit Details
          </div>
          <div class="menu-item" (click)="viewCourseDetails(course)">
            <i class="fa fa-eye"></i> Show Details
          </div>
        </div>
      </span>
    </div>

  </div>


  <div *ngIf="viewMode === 'card'">
    <div class="entity-cardGrid">
      <div class="entity-card" *ngFor="let course of courses">
        <div class="entitycard-header">
          <div class="avatar">{{ course.code[0] }}</div>         
          <i class="fa fa-ellipsis-v menu-icon edit-icon" (click)="toggleMenu($event, course)"></i>
          <div class="dropdown-menu"  [ngClass]="{'show': course.id ===selectedCourseId}" #menu>
            <div class="menu-item" (click)="editCourse(course)">
              <i class="fa fa-pencil"></i> Edit
            </div>
            <div class="menu-item" (click)="viewCourseDetails(course)">
              <i class="fa fa-eye"></i> Show Details
            </div>
          </div>

        </div>

        <div class="card-body">
          <h3 class="entity-name">{{ course.name }}</h3>

          <p class="info-line">
            <i class="fa fa-flask"></i> {{ getLabCount(course) }} Labs
          </p>
          <p class="info-line">
            <i class="fa fa-tag"></i> {{ course.provider }}
          </p>
          <p class="info-line">
            <i class="fa fa-file-text"></i> {{ course.description }}
          </p>
        </div>
      </div>
    </div>
  </div>

</div>